var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.61423 11.2244C2.90285 11.523 2.46131 12.0545 2.45463 12.807C2.45004 13.3331 2.80507 14.0397 3.51644 14.3285C3.80946 14.4477 7.9236 15.0011 7.9236 15.0011C7.9236 15.0011 9.01254 18.4431 9.40498 19.6528C9.51862 20.0028 9.58337 20.1745 9.83274 20.4031C10.2558 20.7903 10.971 20.6689 11.2803 20.3583C12.0987 19.538 13.3921 18.2725 13.3921 18.2725L13.9365 18.7155C13.9365 18.7155 16.3538 20.6437 17.6752 21.5516C18.4531 22.0864 18.9931 22.6442 19.8688 22.6475C20.3148 22.6497 21.0302 22.4277 21.5032 21.8862C21.8157 21.5286 22.0161 20.9566 22.0937 20.4436C22.27 19.2787 24.3384 6.68313 24.3296 6.24235C24.3156 5.53907 23.724 5.14312 23.2323 5.1475C22.9234 5.15078 22.6689 5.24048 22.1025 5.41329C17.7216 6.75095 3.9044 11.103 3.61423 11.2244ZM19.9546 8.42875C19.9546 8.42875 14.1818 13.4534 11.875 15.7656C11.1359 16.5061 11.0838 17.777 11.0838 17.777L9.89137 13.962L19.9546 8.42875Z",
    fill: "#5030E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.a9e52891f5771c25d25b7382610e53c6.svg";
export { ForwardRef as ReactComponent };